import L from 'leaflet';
import { Marker } from './Marker';
import iconUnknown from '@outdoria/ui/assets/icons_new/Unknown.svg';
import { useAdminGetAllMarkers } from '@outdoria/api';
import { addCdnUrl } from '@outdoria/ui';

type Props = {
  selectedMarker: string | null;
  setIsCreateView: (isCreateView: boolean) => void;
  setSelectedMarker: (selectedMarker: string) => void;
};
export const ExistingMarkers = ({
  selectedMarker,
  setIsCreateView,
  setSelectedMarker,
}: Props) => {
  const { data: markers } = useAdminGetAllMarkers();

  return (
    <>
      {markers.map(marker => {
        const { marker_id, coords_x, coords_y, thumbnail } = marker;
        const iconUrl = thumbnail ? addCdnUrl(thumbnail) : iconUnknown;
        const position = L.latLng(coords_x, coords_y);
        const isSelected = marker_id === selectedMarker;

        const onClick = () => {
          setSelectedMarker(marker_id);
          setIsCreateView(false);
        };

        return (
          <Marker
            key={marker_id}
            iconUrl={iconUrl}
            isSelected={isSelected}
            markerId={marker_id}
            position={position}
            onClick={onClick}
          />
        );
      })}
    </>
  );
};
